import { render, staticRenderFns } from "./EditFullTextUpdate.vue?vue&type=template&id=2354de40&"
import script from "./EditFullTextUpdate.vue?vue&type=script&lang=js&"
export * from "./EditFullTextUpdate.vue?vue&type=script&lang=js&"
import style0 from "./EditFullTextUpdate.vue?vue&type=style&index=0&id=2354de40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports